import { useMemo } from 'react';
import { useFoodProfileData } from '@hungryroot/rest-hooks';

export function useFoodProfileRatableTagIds(
  options: { enabled?: boolean } = {}
): number[] {
  const { data: foodProfile } = useFoodProfileData(options);

  return useMemo(() => {
    const proteinTagIds = foodProfile?.ratable_tags.protein || [];
    const sauceTagIds = foodProfile?.ratable_tags.sauces || [];
    const veggieTagIds = foodProfile?.ratable_tags.veggies || [];
    return [...proteinTagIds, ...sauceTagIds, ...veggieTagIds];
  }, [
    foodProfile?.ratable_tags.protein,
    foodProfile?.ratable_tags.sauces,
    foodProfile?.ratable_tags.veggies,
  ]);
}
